export default class SelectLocations {

    constructor() {

        this.bindUIActions();

    }

    bindUIActions() {

        if($('#map-canvas').length != 0) {
            let geocoder, map, marker;

            // Basic map setup
            function initialize() {
                geocoder = new google.maps.Geocoder();

                const mapStyles = [
                    {
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#bdbdbd"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dadada"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#c9c9c9"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    }
                ];

                var mapOptions = {
                    zoom: 16,
                    styles: mapStyles,
                }

                map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

                // On init also run the selectAddress function
                selectAddress();
            }

            // Geocode the address - pass in the address
            function geocodeIt(address) {
                geocoder.geocode( { 'address': address}, function(results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {

                        const pin = document.getElementById('map-pin').src;
                        map.setCenter(results[0].geometry.location);

                        marker = new google.maps.Marker({
                            map: map,
                            position: results[0].geometry.location,
                            animation: google.maps.Animation.DROP,
                            opacity: 1.0,
                            icon: pin
                        });

                    } else {
                        alert('Geocode was not successful for the following reason: ' + status);
                    }
                });
            }

            function selectAddress() {
                var officeLocations = $('#office-locations'),
                    address = officeLocations.find('option:selected').val();
                // Add a marker of the default selected option
                geocodeIt(address);

                // On 'changing' the select remove current marker and then add the newly selected one
                officeLocations.on('change', function() {
                    address = officeLocations.find('option:selected').val();
                    marker.setMap(null);
                    geocodeIt(address);
                });
            }

            function drop() {
                setTimeout(function() {
                    addMarker();
                },200);
            }

            $(window).on('load', function(){
                initialize();
            });

            // Change the location info on select change
            let selectLocation = () => {

                let $selectedLocation = $('#office-locations option').filter(':selected').val();
                let $locations = $('div[data-office-location]');
                let $locationsArray = $locations.toArray();

                $locationsArray.forEach((loc) => {
                    if(loc.getAttribute('data-office-location') === $selectedLocation) {
                        loc.classList.remove('hidden');
                    } else {
                        loc.classList.add('hidden');
                    }
                });

            }

            let onSelectChange = function() {
                selectLocation();
            }

            $('#office-locations').change(onSelectChange);
        }

    }
}

new SelectLocations();